<script lang="ts">
	import { auth } from "../stores";

	export let u: string = "HITIT_BYPASS_USERNAME";
	export let p: string = "HITIT_BYPASS_PASSWORD";
	export let refreshToken = "";

	function moveToSSO() {
		location.assign(
			`${"HITIT_BACKEND_URL"}oauth/authorize?response_type=code&client_id=web&redirect_uri=${"HITIT_HUB_URL"}login&scope=CLIENT`
		);
	}
	if (u && p) {
		$auth.bypassLogin(u, p);
	} else if (refreshToken) {
		(async () => {
			try {
				await $auth.checkRefreshToken();
			} catch (error) {
				moveToSSO();
			}
		})();
	} else {
		moveToSSO();
	}
</script>
